import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function serviceManagerReducer(state = initialState.scopes, action) {
    switch (action.type) {
        case types.LOAD_SM_SCOPES_SUCCESS:
            return action.scopes;
        default:
            return state;
    }
}
